module.exports = __webpack_public_path__ + "static/moonamar-caramelos-con-comino-negro-curcuma-y-menta-3dd44edf44d3f66f56ff62a8e86743e3.png";